import { ChangeDetectionStrategy, Component, input, OnInit, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'lib-ikp-search-bar',
  imports: [ReactiveFormsModule],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarComponent implements OnInit {
  searchInput = new FormControl('');
  isUserInput = signal(false);
  readonly dataTest = input<string>();
  readonly triggerSearch = output<string>();

  ngOnInit(): void {
    this.searchInput.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((input: string) => {
      this.search();
      this.isUserInput.set(input.length > 0);
    });
  }

  search() {
    this.triggerSearch.emit(this.searchInput.value);
  }

  reset() {
    this.searchInput.setValue('');
    this.triggerSearch.emit(this.searchInput.value);
  }
}
